// import React, { useState, useRef, useEffect } from "react";
// import Icon from "../../assets/icons/Icon";
// import Button from "./Button";
// import { toast } from "react-toastify";

// const Importfileconfirmbtn = ({ onCancel, importtemplatefilepath, handleUploadClick, fileType, selectedFile }) => {
//   const modalRef = useRef(null);
//   const [fileName, setFileName] = useState("");

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (modalRef.current && !modalRef.current.contains(event.target)) {
//         onCancel();
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [onCancel]);

//   const triggerFileInput = () => {
//     document.getElementById('file-input').click();
//   };

//   const handleFileChange = (event) => {
//     const file = event.target.files[0];
//     if (file) {
//       setFileName(file.name);

//       if (file.name.endsWith('.csv')) {
//         fileType('.csv');
//         selectedFile(file);
//       } else if (file.name.endsWith('.xlsx') || file.name.endsWith('.xls')) {
//         fileType('.xls');
//         selectedFile(file);
//       } else {
//         toast.error("Unsupported file type");
//         setFileName("");
//       }
//     }
//   };
//   return (
//     <div className="fixed inset-0 bg-[#02080E80] flex justify-center items-center z-50">
//       <div
//         ref={modalRef}
//         className="bg-white p-8 rounded-lg shadow-xl w-96 relative"
//       >
//         {/* Close Button */}
//         {/* <button
//           onClick={onCancel}
//           className="absolute top-2 right-2 text-gray-500 hover:text-gray-600 w-7 cursor-pointer"
//         >
//         <Icon type="remove"/>
//         </button> */}


//         {/* Title */}
//         <div style={{ backgroundColor: "lightgrey", padding: "5%", borderRadius: "10px" }}>


//           <h2 className="text-xl font-bold  text-gray-800">
//             Info
//           </h2>

//           {/* Description */}
//           <p className="text-gray-600 mt-3 ">
//             - Maximum of 2000 rows allowed per file upload.
//             <br />
//             - Click here to download import template.
//             <br />

//           </p>
//           {/*/import_template_file/MembershipImportV1.csv*/}
//           <a href={importtemplatefilepath} download="membershiptemplate.csv">
//             <h5 className="hover:text-violet-600 cursor-pointer">Import template</h5>
//           </a>
//         </div>

//         <p>

//         <div className="mt-4">
//           <div className="flex items-center justify-between gap-3 bg-gray-50 p-3 rounded-lg">
//             {fileName ? (
//               <>
//                 <div className="flex items-center gap-2 flex-1 min-w-0">
//                   <span className="w-5">
//                     <Icon type="file" />
//                   </span>
//                   <span className="truncate text-sm font-medium">
//                     {fileName}
//                   </span>
//                 </div>
//                 <Button 
//                   type="secondary" 
//                   px="px-4" 
//                   onClick={triggerFileInput}
//                   className="whitespace-nowrap"
//                 >
//                   Replace
//                 </Button>
//               </>
//             ) : (
//               <Button 
//                 type="primary" 
//                 px="px-4" 
//                 onClick={triggerFileInput}
//                 className="w-full"
//               >
//                 Choose File
//               </Button>
//             )}
//           </div>
//           <input
//             type="file"
//             id="file-input"
//             style={{ display: 'none' }}
//             onChange={handleFileChange}
//             accept=".csv, .xlsx, .xls"
//           />
//         </div>
//         </p>

//         {/* Button Container */}
//         <div className="flex justify-center gap-4 mt-6">
//           {/* Cancel Button */}
//           <button
//             onClick={onCancel}
//             className="bg-gray-600 text-white  py-2 px-6 rounded-lg shadow-lg hover:bg-gray-700 transition duration-300 cursor-pointer"
//           >
//             Cancel
//           </button>

//           {/* Confirm Button */}
//           <button
//             // Handle file upload logic here
//             onClick={handleUploadClick}
//             className="bg-green-600 text-white  py-2 px-6 rounded-lg shadow-lg hover:bg-green-700 transition duration-300 cursor-pointer"
//           >
//             Upload
//           </button>

//         </div>
//       </div>
//     </div>
//   );
// };

// export default Importfileconfirmbtn;


import React, { useState, useRef, useEffect } from "react";
import Icon from "../../assets/icons/Icon";
import Button from "./Button";
import { toast } from "react-toastify";
import PopupModal from "./PopupModal";

const Importfileconfirmbtn = ({ onCancel, importtemplatefilepath, handleUploadClick, fileType, selectedFile,errorMessage,loading,importTemplateFileFunction }) => {
  const modalRef = useRef(null);
  const [fileName, setFileName] = useState("");

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onCancel();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onCancel]);

  const triggerFileInput = () => {
    document.getElementById('file-input').click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setFileName(file.name);

      if (file.name.endsWith('.csv')) {
        fileType('.csv');
        selectedFile(file);
      } else if (file.name.endsWith('.xlsx') || file.name.endsWith('.xls')) {
        fileType('.xls');
        selectedFile(file);
      } else {
        toast.error("Unsupported file type");
        setFileName("");
      }
    }
  };

  return (
    <PopupModal
          setPopUp={onCancel}
          size="w-[30vw] max-h-[95vh]"
          saveClick={handleUploadClick}
          handleClose={onCancel}
          buttons={true}
          secondbtnname={"Upload"}
          primaryBtnDisabled={(fileName || !loading) ? false : true}
          title={"Import File"}
        >


    {/* Content section */}
    <div>
 
  
{errorMessage &&
  <div className="flex gap-4">
    <div className="text-red-700 font-semibold">Error Occurred:</div>
    <div className="break-words flex-1">
      {errorMessage}
    </div>
  </div>
} 
    <div className="">
  
      {/* Info card */}
      <div className="bg-[#f9f9fb] border-l-4 border-indigo-500 rounded-lg p-3 sm:p-4 mb-4 sm:mb-6">
        <div className="text-[15px] sm:text-[16px] mb-2 flex items-center">
          Important Information
        </div>
        <ul className="text-(--tab-gray) space-y-1 pl-4 sm:pl-5 list-disc text-sm sm:text-base">
          <li>Maximum of 10000 rows allowed per file upload</li>
          <li>Only CSV and Excel files are supported</li>
        </ul>

        <div className="mt-3 flex items-center gap-3 sm:gap-5">
         {importtemplatefilepath && <a
            href={importtemplatefilepath}
            download="membershiptemplate.csv"
            className="flex items-center text-indigo-600 hover:text-indigo-800 font-medium transition-colors text-xs sm:text-sm cursor-pointer"
          >
            <span className="w-4 sm:w-5">
              <Icon type={"download"} />
            </span>
            <span className="ml-1">
              Download Import Template
            </span>
          </a> }
          {importTemplateFileFunction && <a
            onClick={importTemplateFileFunction}
            className="flex items-center text-indigo-600 hover:text-indigo-800 font-medium transition-colors text-xs sm:text-sm cursor-pointer"
          >
            <span className="w-4 sm:w-5">
              <Icon type={"download"} />
            </span>
            <span className="ml-1">
              Download Import Template
            </span>
          </a>}
        </div>
      </div>

      {/* File upload area */}
      <div className="bg-[#f9f9fb] border-[1px] border-[#d7d5e2] hover:border-[#6e2d90] border-dashed rounded-lg">
        <div className="py-4 sm:py-5">
          <div className="flex flex-col justify-center items-center mt-3 sm:mt-5">
            {fileName ? (
              <div className="flex flex-col justify-center items-center">
                <span className="w-[45px] sm:w-[55px] text-[#6e2d90]">
                  <Icon type={"file"} />
                </span>
                <div className="mt-2 text-sm sm:text-base">{fileName}</div>
              </div>
            ) : (
              <>
                <div
                  className="h-[45px] w-[45px] sm:h-[55px] sm:w-[55px] border-[1px] border-[#d7d5e2] rounded-lg flex justify-center items-center hover:text-[#6e2d90] text-[#6c718a]"
                  style={{
                    boxShadow: "0 2px 10px rgba(177, 176, 186, 0.5), 0 4px 6px rgba(0, 0, 0, 0.1)"
                  }}
                >
                  <span className="h-[20px] w-[20px] sm:h-[25px] sm:w-[25px]">
                    <Icon type="download" />
                  </span>
                </div>
                <div className="mt-3 sm:mt-5 text-sm sm:text-base">Drag and drop file to import</div>
              </>
            )}
          </div>

          <div className="flex flex-col justify-center items-center">
            <div className="mt-3 sm:mt-5">
              <Button type="primary" disabled={loading} px="px-3 sm:px-4" onClick={triggerFileInput}>
                {fileName ? "Replace File" : "Choose File"}
              </Button>
              <input
                type="file"
                id="file-input"
                style={{ display: 'none' }}
                onChange={handleFileChange}
                accept=".csv, .xlsx, .xls"
              />
            </div>

            <div className="mt-3 sm:mt-5 text-(--list-item-gray) text-xs sm:text-sm text-center px-2">
              Maximum File Size: 25 MB • File Format: CSV, TSV, or XLS
            </div>
          </div>
        </div>
      </div>
    </div>
</div>
   

</PopupModal>
  );
};

export default Importfileconfirmbtn;
